import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseAdvertisments() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      id: isEmpty(state.id),
      groupID: isEmpty(state.groupID),
    };

    setter(errorState);

    if (errorState.title || errorState.id || errorState.groupID) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getAdvertismentList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Advertisments?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllAdvertismentList = (callback) => {
    MyAxios.get(`Admin_Advertisments?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAdvertismentByID = (id, callback) => {
    MyAxios.get(`Admin_Advertisments/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateAdvertisment = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file) {
      data.append("Image", file);
    }
    MyAxios.post(`Admin_Advertisments`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addAdvertisment = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file) {
      data.append("Image", file);
    }
    MyAxios.post(`Admin_Advertisments`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteAdvertisment = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Advertisments`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addAdvertismentTariff = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Advertisments/Tariff`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteAdvertismentTariff = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Advertisments/Tariff`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const addAdvertismentDescription = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Advertisments/Description`, data, {}).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const deleteAdvertismentDescription = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Advertisments/Description`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getAdvertismentList,
    getAllAdvertismentList,
    getAdvertismentByID,
    validate,
    updateAdvertisment,
    addAdvertisment,
    deleteAdvertisment,
    addAdvertismentTariff,
    deleteAdvertismentTariff,
    addAdvertismentDescription,
    deleteAdvertismentDescription,
  };
}
